export class Expression {
    leftSide: Term | Expression | Brackets
    operation: string
    rightSide: Term | Expression | Brackets

    constructor(leftSide: Term | Expression | Brackets, operation: string, rightSide: Term | Expression | Brackets) {
        this.leftSide = leftSide
        this.operation = operation
        this.rightSide = rightSide
    }

    and = (expression: Expression): Expression => new Expression(this, "and", expression)
    or = (expression: Expression): Expression => new Expression(this, "or", expression)
    print = (first: boolean = true) =>
        !(this.leftSide instanceof Term)
            ? `(${this.leftSide.print(first)}).${this.operation}(${this.rightSide.print(false)})`
            : `${this.leftSide.print()}.${this.operation}(${this.rightSide.print(false)})`
}
type ValueType = string | number | boolean
export class Term {
    name: string | boolean | number

    constructor(name: string | boolean | number) {
        this.name = name
    }

    // Equal
    eq = (value: ValueType): Expression => new Expression(this, "eq", new Term(value))
    // Not Equal
    ne = (value: ValueType): Expression => new Expression(this, "ne", new Term(value))
    // Starts with
    sw = (value: ValueType): Expression => new Expression(this, "sw", new Term(value))
    // Ends with
    ew = (value: ValueType): Expression => new Expression(this, "ew", new Term(value))
    // Greater than
    gt = (value: ValueType): Expression => new Expression(this, "gt", new Term(value))
    // Greater or equal
    ge = (value: ValueType): Expression => new Expression(this, "ge", new Term(value))
    // Less than
    lt = (value: ValueType): Expression => new Expression(this, "lt", new Term(value))
    // Less or equal
    le = (value: ValueType): Expression => new Expression(this, "le", new Term(value))
    ll = (value: ValueType): Expression => new Expression(this, "ll", new Term(value))
    // Contains
    ct = (value: ValueType): Expression => new Expression(this, "ct", new Term(value))
    // In
    inRange = (value: ValueType[]): Expression => new Expression(this, "in", new Term(value.join(",")))
    // Not in
    ni = (value: ValueType): Expression => new Expression(this, "ni", new Term(value))
    // Upper
    up = (value: ValueType): Expression => new Expression(this, "up", new Term(value))
    // Lower
    ow = (value: ValueType): Expression => new Expression(this, "ow", new Term(value))
    // Is null
    isNull = (): Expression => new Expression(this, "null", T(""))
    print = () => String(this.name)
}
export class Brackets {
    content: Term | Expression | Brackets

    constructor(content: Term | Expression | Brackets) {
        this.content = content
    }

    print = () => "(" + this.content.print() + ")"
    and = (expression: Expression): Expression => new Expression(this, "and", expression)
    or = (expression: Expression): Expression => new Expression(this, "or", expression)
}

export const B = (content: Term | Expression | Brackets) => new Brackets(content)

export const T = (name: string | boolean | number) => new Term(name)

export const E = (leftSide: Term | Expression, operation: string, rightSide: Term | Expression) =>
    new Expression(leftSide, operation, rightSide)
